import { useState, useEffect } from 'react'
import { Tooltip, Spin, message } from 'antd'
import Modal from 'meinian-package/src/component/modal'
import Button from 'meinian-package/src/baseComponent/button'
import empty from 'image/empty/empty_card_logo.png'
import classNames from 'classnames'
import { request } from 'meinian-package/src/utils'
import Pro2 from 'image/detail/pro2.png'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import useVersionNumber from 'meinian-package/src/common/hooks/useVersionNumber'
import { ossImg } from 'meinian-package/src/utils/image'
import './index.less'

export default () => {
  const [visible, setVisible] = useState(false)
  const { authMeal, isFreezeStatus, isAuthVersion } = useVersionNumber()

  useEffect(() => {
    if (isFreezeStatus() && isAuthVersion(150001) && Object.keys(authMeal).length) {
      setVisible(true)
    }
  }, [authMeal])

  return <span>{visible && <InspirationFreezeModal visible={visible} />}</span>
}

const InspirationFreezeModal = ({ visible, maxSize = 20 }) => {
  const [_visible, set_visible] = useState(visible)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [ids, setIds] = useState([])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setLoading(true)
    const result = await request.post('/zhikuan/ins/inspiration/list-inspiration?start=0&pageSize=2000', {
      pageSize: 2000,
      start: 0,
      queryType: 1,
      rankStatus: '-2',
      topFirstStatus: 1,
    })
    setLoading(false)
    if (result) {
      result.resultList.sort((a, b) => a.isPro - b.isPro)
      setData(result.resultList)
    }
  }
  const onOk = async () => {
    const result = await request.post('/zhikuan/ins/inspiration/auth/freeze-inspiration', ids)
    if (result) {
      message.success('保留成功')
      set_visible(false)
    }
  }

  const onItemChecked = (item) => {
    if (item.isPro) {
      return
    }
    const _index = ids.findIndex((i) => i === item.id)
    if (_index !== -1) {
      ids.splice(_index, 1)
    } else if (ids.length < maxSize) {
      ids.push(item.id)
    }
    setIds((pre) => [...pre])
  }

  return (
    <Modal
      hiddenCloseIcon
      visible={_visible}
      style={{ width: '960px' }}
      onClose={() => set_visible(false)}
      footer={
        <div className="mn-inspiration-keep-modal-footer">
          <div style={{ fontSize: '16px', color: 'var(--m-text-1)' }} className="df-center-center">
            <span style={{ fontSize: '14px', marginLeft: '16px' }}>已选择</span>
            <span style={{ fontSize: '16px', marginLeft: '4px' }}>{ids.length}</span>
            <span style={{ fontSize: '16px', marginLeft: '4px' }}>/</span>
            <span style={{ color: 'var(--m-text-3)', marginLeft: '4px' }}>{maxSize}</span>
          </div>
          <Button type="primary" style={{ width: '96px' }} onClick={() => onOk()}>
            确定
          </Button>
        </div>
      }
    >
      <div className="mn-inspiration-keep-modal">
        <div className="mn-inspiration-keep-modal-header">
          <div className="mn-inspiration-keep-modal-title">选择要保留使用的灵感集</div>
          <div className="mn-inspiration-keep-modal-sub-title">
            由于您当前团队的美念版本降级为基础版，每个人只能创建20个灵感集，请选择您要保留的20个灵感集，剩余灵感集将被冻结使用（仅可查看）
            <br />
            灵感集PRO无法在基础版里使用，想要继续使用请升级版本
          </div>
        </div>
        <Spin spinning={loading}>
          <div className="mn-inspiration-keep-modal-middle">
            {data.map((item) => (
              <div
                key={item}
                onClick={() => {
                  onItemChecked(item)
                }}
                className={classNames('mn-inspiration-keep-modal-middle-item', {
                  active: ids.some((i) => i === item.id),
                  disabled: item.isPro,
                })}
              >
                <img src={ossImg(item.coverImgUrl) || empty} className="mn-inspiration-keep-modal-middle-item-img" />
                <div className="mn-inspiration-keep-modal-middle-item-right-info">
                  <div className="mn-child-inspiration-card-info">
                    <Tooltip title={item.name}>
                      <div className="mn-inspiration-keep-modal-middle-item-title text-overflow">
                        {item.isPro === 1 && <img src={Pro2} className="coll-info-img" />}
                        {item.name}
                      </div>
                    </Tooltip>
                    <div className="info">
                      <span>款式</span>
                      <span style={{ color: 'var(--m-text-1)', marginLeft: '2px' }}>{item?.blogNum}</span>
                      <div className="line" />
                      <div className="user">{item?.userName}</div>
                      创建
                    </div>
                  </div>
                </div>
                <div className="mn-inspiration-keep-modal-middle-item-action">
                  <Checkbox
                    disabled={item.isPro}
                    checked={ids.some((i) => i === item.id)}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => onItemChecked(item)}
                  />
                </div>
              </div>
            ))}
          </div>
        </Spin>
      </div>
    </Modal>
  )
}
